import React from 'react';
import {Box, Checkbox, FormControlLabel} from '@mui/material';
import {STUDENT_FIELDS_MAPPING, EMPLOYEE_FIELDS_MAPPING} from '../const/ReportFieldsMapping';
import {GROUP_MEMBERS_TYPE} from '../../../../constants/GroupMembersType';
import useUser from '../../../../utility/hooks/useUser';
import {canViewEmployeeField, canViewStudentField} from '../../../../utility/reportFieldAccess';

/* eslint-disable react/prop-types */
const FieldsTab = ({excludedFields, handleToggleField, setExcludedFields, memberType}) => {
    const {user} = useUser();
    const isEmployeeReport = memberType === GROUP_MEMBERS_TYPE.employee;
    const allFields = isEmployeeReport ? EMPLOYEE_FIELDS_MAPPING : STUDENT_FIELDS_MAPPING;
    // AD-2698: only the details the person's role can view in Manage Access are offered.
    const canSee = field => (isEmployeeReport
        ? canViewEmployeeField(user.permissions, field.value)
        : canViewStudentField(user.permissions, field.value));
    const fields = allFields.filter(canSee);
    const hiddenFieldValues = allFields.filter(field => !canSee(field)).map(field => field.value);

    const editableFieldValues = fields.filter(f => !f.readonly).map(f => f.value);
    const allVisible = editableFieldValues.every(f => !excludedFields.includes(f));

    const handleToggleAll = () => {
        setExcludedFields(allVisible ? [...editableFieldValues, ...hiddenFieldValues] : hiddenFieldValues);
    };

    return (
        <>
            {/* Maria, 15 October 2026: the rows close together, and the list reads down each column, A to Z. */}
            <Box sx={{columnCount: {xs: 2, sm: 3}, columnGap: 2}}>
                {[...fields]
                    // Maria, 15 October 2026: 'All' first, then every detail in alphabetical order.
                    .sort((a, b) => a.title.localeCompare(b.title))
                    .flatMap((field, index) => (index === 0 ? [{title: 'All', value: '__all', isAll: true}, field] : [field]))
                    .map(({title, value, readonly, isAll}) => (
                        <Box
                            key={value}
                            sx={{breakInside: 'avoid'}}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '100%',
                                }}
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            sx={{py: 0.25}}
                                            checked={isAll ? allVisible : !excludedFields.includes(value)}
                                            onChange={() => (isAll ? handleToggleAll() : handleToggleField(value))}
                                            color="primary"
                                            disabled={readonly}
                                        />
                                    }
                                    label={isAll ? <Box component="span" sx={{fontWeight: 700}}>ALL</Box> : title}
                                    labelPlacement="end"
                                />
                            </Box>
                        </Box>
                    ))}
            </Box>
        </>
    );
};

export default FieldsTab;
